import { createSlice, type PayloadAction } from '@reduxjs/toolkit';

interface MediaCaptionState {
  loading: boolean;
  error: string | null;
  success: boolean;
}

const initialState: MediaCaptionState = {
  loading: false,
  error: null,
  success: false,
};

const mediaCaptionSlice = createSlice({
  name: 'mediaCaption',
  initialState,
  reducers: {
    updateMediaCaptionRequest: (
      state,
      action: PayloadAction<{
        campaignId: string;
        restaurantId: string;
        platform: string;
        postCopy: string;
      }>
    ) => {
      state.loading = true;
      state.error = null;
      state.success = false;
    },
    updateMediaCaptionSuccess: (state) => {
      state.loading = false;
      state.success = true;
    },
    updateMediaCaptionFailure: (state, action: PayloadAction<string>) => {
      state.loading = false;
      state.error = action.payload;
      state.success = false;
    },
    resetMediaCaptionState: (state) => {
      state.loading = false;
      state.error = null;
      state.success = false;
    },
  },
});

export const {
  updateMediaCaptionRequest,
  updateMediaCaptionSuccess,
  updateMediaCaptionFailure,
  resetMediaCaptionState,
} = mediaCaptionSlice.actions;

export default mediaCaptionSlice.reducer;
